import React, { useEffect } from "react";

//Import Breadcrumb
import { Divider, FormHelperText, Grid, InputAdornment, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { connect, useDispatch } from 'react-redux';
import CustomAutocomplete from "../../../components/Form/CustomAutocomplete";
import CustomButton from "../../../components/Form/CustomButton";
import CustomIconButton from "../../../components/Form/CustomIconButton";
import CustomSelect from "../../../components/Form/CustomSelect";
import CustomTextField from "../../../components/Form/CustomTextField";
import Helpers from "../../../helpers/helpers";
import { getProductListingForAccessories } from "../../../store/actions";
import "../../Orders/order.css";
import Table from "./Table";

const AccessoriesField = ({ setOpenAccessoriesField, tempAccessories, error, setTempAccessories, setNotification, errorQty, edit, setEditId, handleSaveEdit, id,
    handleAddAccessories, handleAddProduct, productListing, categoryListing,
    setTempProduct, tempProduct, setError, setErrorQty, useeffectIndicator
}) => {
    const handleDeleteAccessories = (idx) => {
        setTempAccessories((prevValue) => ({
            ...prevValue,
            items: prevValue?.items?.filter((_, index) => index !== idx),
        }));
    }
    const dispatch = useDispatch()
    const [isSorted, setSorted] = useState(false)
    const [isSortedDesc, setSortedDesc] = useState(false)
    const [data, setData] = useState(tempAccessories?.items)
    const [productUpsellList, setProductUpsellList] = useState(productListing)

    useEffect(() => {
        if (tempAccessories?.items)
            setData(tempAccessories?.items)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tempAccessories?.items]);

    useEffect(() => {
        let filtered = [];
        if (productListing) {
            if (tempAccessories && tempAccessories.items?.length > 0) {
                filtered = productListing.filter(
                    (itemA) =>
                        !tempAccessories.items.some(
                            (itemB) => itemB.upsell_product_id === itemA.id
                        )
                );
                setProductUpsellList(filtered);
            } else {
                setProductUpsellList(productListing);
            }
        }
    }, [productListing, useeffectIndicator]);


    const handleSort = (columnID) => {
        // Sort the data based on the column and direction
        const sorted = [...data].sort((a, b) => {
            const aValue = a[columnID];
            const bValue = b[columnID];

            // Check if the values are strings
            if (typeof aValue === 'string' && typeof bValue === 'string') {
                return isSortedDesc
                    ? bValue.localeCompare(aValue)  // Sort in descending order
                    : aValue.localeCompare(bValue);  // Sort in ascending order
            }

            // Check if the values are numbers
            if (typeof aValue === 'number' && typeof bValue === 'number') {
                return isSortedDesc ? bValue - aValue : aValue - bValue;  // Sort numerically
            }

            return 0;  // If data types are different or unsupported, do not change the order
        });

        // Update the state with the sorted data
        setData(sorted);

    };

    const handleDiscoutChg = (val, index, data) => {
        if (data?.["is_percentage"] === 1 && val > 100) {
            setNotification({ open: true, msg: 'Discount percentage cannot exceed 100%', type: 'warning' });
            return;
        } else if (data?.["is_percentage"] === 0 && val > data?.upsell_aspeed_price) {
            setNotification({ open: true, msg: 'Discount value cannot exceed unit price', type: 'warning' });
            return;
        } else {
            setTempAccessories((prevValues) => ({
                ...prevValues,
                items: prevValues?.items?.map((item, i) =>
                    i === index // Compare the index
                        ? { ...item, discount_value: val } // Update only the matching element
                        : item // Keep other elements unchanged
                ),
            }))
        }
    }


    const header = [
        {
            Header: "Accessories",
            columnID: "upsell_product_name",
            accessor: (cellProps, idx) => {
                return (
                    <React.Fragment>
                        <Typography sx={{ '&:hover': { color: "#7BB9FA" } }}>{cellProps?.upsell_product_name}</Typography>
                        <Typography sx={{ fontSize: "14px", fontWeight: 400, color: "#999999" }}>Category: {cellProps?.upsell_category_name} </Typography>
                        <Typography sx={{ fontSize: "14px", fontWeight: 400, color: "#999999" }}>Price: <span style={{ textDecoration: "line-through", textDecorationColor: "#282828" }}>S${cellProps?.upsell_aspeed_price} </span> &nbsp; <span style={{ color: "#282828" }}>
                            {tempAccessories?.items?.[idx]?.is_percentage == 1 ?
                                `S$` + (cellProps?.upsell_aspeed_price - (cellProps?.upsell_aspeed_price * tempAccessories?.items?.[idx]?.discount_value / 100))
                                :
                                `S$` + (cellProps?.upsell_aspeed_price - (tempAccessories?.items?.[idx]?.discount_value))
                            }</span></Typography>
                    </React.Fragment>
                )
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Sort Order",
            columnID: "sort_order",
            accessor: (cellProps, idx) => {
                return (
                    <React.Fragment>
                        <CustomTextField
                            values={cellProps?.sort_order}
                            error={error && error?.sort_order}
                            placeholder={"e.g. 0"}
                            onChange={(e) => setTempAccessories((prevValues) => ({
                                ...prevValues,
                                items: prevValues?.items?.map((item, i) =>
                                    i === idx // Compare the index
                                        ? { ...item, sort_order: e } // Update only the matching element
                                        : item // Keep other elements unchanged
                                ),
                            }))}
                            type="number"
                        />
                    </React.Fragment>
                )
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Discount (optional)",
            columnID: "is_percentage",
            accessor: (cellProps, idx) => {
                return (
                    <React.Fragment>
                        <CustomSelect
                            values={cellProps?.is_percentage}
                            valueName={"id"}
                            error={error && cellProps?.is_percentage === "" && "The discount field is required."}
                            labelName={"name"}
                            placeholder={""}
                            onChange={(e) => setTempAccessories((prevValues) => ({
                                ...prevValues,
                                items: prevValues?.items?.map((item, i) =>
                                    i === idx // Compare the index
                                        ? { ...item, is_percentage: e, discount_value: "" } // Update only the matching element
                                        : item // Keep other elements unchanged
                                ),
                            }))}
                            InputProps={{
                                startAdornment: <InputAdornment position="end" className='auth-icon'>%</InputAdornment>,
                            }}
                            data={Helpers.is_percentage}
                        />
                        <div style={{ width: "120px" }}>
                            <CustomTextField
                                values={cellProps?.discount_value}
                                error={error && (cellProps?.discount_value === null || cellProps?.discount_value === undefined || cellProps?.discount_value === "") && "The discount field is required."}
                                onChange={(e) =>
                                    handleDiscoutChg(e, idx, cellProps)
                                }
                                InputProps={{
                                    endAdornment: <InputAdornment position={"end"} className='auth-icon'>{(cellProps.is_percentage === 1) ? "%" : ""}</InputAdornment>,
                                    startAdornment: <InputAdornment position={"start"} className='auth-icon'>{(cellProps.is_percentage !== 1) ? "S$" : ""}</InputAdornment>,
                                }}
                                type="price"
                            />
                        </div>

                    </React.Fragment>
                )
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Additional Info",
            columnID: "additional_info",
            accessor: (cellProps, idx) => {
                return (
                    <React.Fragment>
                        <CustomTextField
                            values={cellProps?.additional_info}
                            error={error && error?.additional_info}
                            placeholder={"Use | or Enter for new lines"}
                            multiline={true}
                            rows={3}
                            onChange={(e) => setTempAccessories((prevValues) => ({
                                ...prevValues,
                                items: prevValues?.items?.map((item, i) =>
                                    i === idx // Compare the index
                                        ? { ...item, additional_info: e } // Update only the matching element
                                        : item // Keep other elements unchanged
                                ),
                            }))}
                            // type="number"
                        />
                    </React.Fragment>
                )
            },
            disableFilters: true,
            filterable: false,
        },
        // {
        //     Header: "Min. order qty",
        //     columnID: "min_purchase_qty",
        //     accessor: (cellProps, idx) => {
        //         return (
        //             <React.Fragment>
        //                 <CustomTextField
        //                     values={cellProps?.min_purchase_qty}
        //                     error={error ? Helpers?.isNullOrEmptyAllowZero(cellProps?.min_purchase_qty) && "The min purchase quantity field is required." : errorQty && parseInt(cellProps?.min_purchase_qty) > parseInt(cellProps?.max_purchase_qty) && "Min order quantity must be less than max order quantity"}
        //                     onChange={(e) => {
        //                         handleQtyChange(e, "min_purchase_qty", "child", idx, "Min. order qty")
        //                     }}
        //                     type="integer_allow_0"
        //                 />
        //             </React.Fragment>
        //         )
        //     },
        //     disableFilters: true,
        //     filterable: false,
        // },
        // {
        //     Header: "Max. order qty",
        //     columnID: "max_purchase_qty",
        //     accessor: (cellProps, idx) => {
        //         return (
        //             <React.Fragment>
        //                 <CustomTextField
        //                     values={cellProps?.max_purchase_qty || ""}
        //                     error={error ? Helpers?.isNullOrEmpty(cellProps?.max_purchase_qty) && "The max purchase quantity field is required." : errorQty && parseInt(cellProps?.min_purchase_qty) > parseInt(cellProps?.max_purchase_qty) && "Max order quantity must be more than max order quantity"}
        //                     onChange={(e) => {
        //                         handleQtyChange(e, "max_purchase_qty", "child", idx, "Max. order qty")
        //                     }}
        //                     type="integer_not_allow_0"
        //                 />
        //             </React.Fragment>
        //         )
        //     },
        //     disableFilters: true,
        //     filterable: false,
        // },
        {
            Header: "Action",
            accessor: (cellProps, idx) => {
                return (
                    <React.Fragment>
                        <div className="pt-2">
                            <CustomIconButton
                                iconName={'ri-delete-bin-line'}
                                onClick={(e) => handleDeleteAccessories(idx)}
                                backgroundColor={'#ED1A3D'}
                                color={'white'}
                                borderStyle={"1px solid #ED1A3D"}
                            />
                        </div>
                    </React.Fragment>
                )
            },
            minWidth: 120,
            position: 'sticky',
            disableFilters: true,
            filterable: false,
        }
    ]

    const handleQtyChange = (e, field, type, idx, title) => {
        setTempAccessories((prevValues) => ({
            ...prevValues,
            items: prevValues?.items?.map((item, i) =>
                i === idx // Compare the index
                    ? { ...item, [field]: e } // Update only the matching element
                    : item // Keep other elements unchanged
            ),
        }))

    }

    return (
        <div className="pt-4">
            <Grid container sx={{ border: '1px solid #e0e0e0', borderRadius: "8px", }} p={2} pt={0}>
                <Grid item xs={12} pb={3}>
                    <Stack direction={{ xs: "column-reverse", sm: "row" }} pt={2} gap={1} justifyContent={"space-between"}>
                        <Stack direction={"row"} gap={1} alignItems={"center"}>
                            <div style={{ border: '1px solid #D0D0D0', borderRadius: "5px", height: "42px", width: "42px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <i className="ri-shapes-line" style={{ fontSize: "24px" }}></i>
                            </div>
                            <div>
                                <span className="setting-form-section-header font-size-14" >New options by category </span>
                            </div>
                        </Stack>
                        <div className="d-flex justify-content-end">
                            <CustomButton
                                borderStyle={"1px solid #999999"}
                                title={<span><i className="ri-close-fill me-2"></i>Cancel</span>}
                                press={() => edit ?
                                    (setEditId(), setError(false), setErrorQty(false))
                                    :
                                    (setOpenAccessoriesField(false), setError(false), setErrorQty(false), setTempAccessories({
                                        category_id: "",
                                        min_purchase_qty: "",
                                        max_purchase_qty: "",
                                        items: [],
                                    }))}
                                height={26}
                                backgroundColor={'transparent'}
                                textColor={'#999999'}
                            />
                        </div>
                    </Stack>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item sm={6} xs={12}>
                        <CustomSelect
                            title={'Select Category'}
                            values={tempAccessories?.category_id || '-1'}
                            valueName={"id"}
                            labelName={"category_name"}
                            placeholder={""}
                            onChange={(e) => (
                                setTempAccessories((prevValues) => ({
                                    ...prevValues,
                                    category_id: e,
                                    category_name: Helpers.getValueFromData(categoryListing, parseInt(e), "name"),
                                    items: []

                                })),
                                setData([]),
                                dispatch(getProductListingForAccessories({
                                    keyword: "",
                                    length: "",
                                    sort_by: "",
                                    status: "",
                                    sales_platform: "",
                                    product_type: "",
                                    page: 0,
                                    sort_order: "asc",
                                    sort: "",
                                    category_id: e,
                                })),
                                Helpers.getValueFromData(categoryListing, parseInt(e), "name")
                            )}
                            error={error && !tempAccessories?.category_id && " The category field is required."}
                            data={categoryListing}
                        />
                    </Grid>
                    {/* <Grid item xs={6} sm={3}>
                        <CustomTextField
                            title={'Min. purchase qty'}
                            values={tempAccessories?.min_purchase_qty}
                            error={error ? Helpers?.isNullOrEmptyAllowZero(tempAccessories?.min_purchase_qty) && " The min order quantity field is required." : errorQty && parseInt(tempAccessories?.min_purchase_qty) > parseInt(tempAccessories?.max_purchase_qty) && "Min order quantity must be less than max order quantity"}
                            onChange={(e) => setTempAccessories((prevValues) => ({
                                ...prevValues,
                                min_purchase_qty: e
                            }))}
                            type="integer_allow_0"
                        />
                    </Grid>
                    <Grid item xs={6} sm={3}>
                        <CustomTextField
                            title={'Max. purchase qty'}
                            values={tempAccessories?.max_purchase_qty}
                            error={error ? Helpers?.isNullOrEmpty(tempAccessories?.max_purchase_qty) && " The max order quantity field is required." : errorQty && parseInt(tempAccessories?.min_purchase_qty) > parseInt(tempAccessories?.max_purchase_qty) && "Max order quantity must be more than min order quantity"}
                            onChange={(e) => setTempAccessories((prevValues) => ({
                                ...prevValues,
                                max_purchase_qty: e
                            }))}
                            type="integer_not_allow_0"
                        />
                    </Grid> */}
                    <Grid item xs={12}>
                        <Divider className="my-2 mb-4" />
                    </Grid>
                </Grid>
                {/* category table*/}
                <Grid container spacing={2}>
                    <Grid item xs={8} sm={10.5} >
                        <CustomAutocomplete
                            values={tempProduct}
                            valueName={"id"}
                            labelName={"product_name"}
                            placeholder={"Search for products to upsell"}
                            onChange={(e, value) => setTempProduct(value?.id)}
                            error={error && error?.tempProduct}
                            data={productUpsellList}
                        />
                    </Grid>
                    <Grid item xs={4} sm={1.5} alignItems={"center"} display={"flex"}>
                        <CustomButton
                            title={'Add'}
                            press={() => handleAddProduct()}
                            height={40}
                            backgroundColor={'#101010'}
                            textColor={'white'}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormHelperText style={{ color: "red" }}>{error && tempAccessories?.items?.length == 0 && "The product to upsell field is required."}</FormHelperText>
                        <Stack display={"grid"}>
                            <Table
                                header={header}
                                data={data}
                                totalPage={1}
                                pageSize={tempAccessories?.items?.length}
                                customToolsBar={true}
                                isSorted={isSorted}
                                isSortedDesc={isSortedDesc}
                                setSorted={setSorted}
                                setSortedDesc={setSortedDesc}
                                handleSort={handleSort}
                                module={'configuration-list'}
                            />
                        </Stack>

                    </Grid>

                </Grid>

            </Grid>
            <div className="pt-3">
                <CustomButton
                    title={'Save'}
                    press={() => (edit ? (handleSaveEdit(id)) : (handleAddAccessories()))}
                    height={40}
                    width={"100%"}
                    backgroundColor={'#101010'}
                    textColor={'white'}
                />
            </div>
        </div>
    );
};

function mapStateToProps({ }) {
    return {

    };
}


export default connect(mapStateToProps)(AccessoriesField);
